import { Locale } from '../../../../localization/LocalizationKeys';
import { linkFieldConfig } from '../../person/fields/utils/personFieldsUtils';
import { PermissionEnum, SitePersonCriteriaOrder } from '../../../../gql/typings';


export const linkValidatedByFieldConfig = linkFieldConfig(
  'validatedByUser',
  [
    'validatedByUser.id',     
    'validatedByUser.fullname',    
  ],
  

  ({ localization }) => ({
    permission: PermissionEnum.VALIDATE_RECORD,
    title: localization.formatMessage(Locale.Attribute.ValidatedBy),    
    additionalTableConfig: {
      width: 125
    },
    sorting: {
      ascend: SitePersonCriteriaOrder.VALIDATED_BY_USER_FULLNAME_ASC,
      descend: SitePersonCriteriaOrder.VALIDATED_BY_USER_FULLNAME_DESC,
    },
    render: (record) => record.validatedByUser?.fullname ?? '',
  })
);
